// extracted by mini-css-extract-plugin
export default {"spinner":"PaginatedBookGrid_spinner__eJllV","spin":"PaginatedBookGrid_spin__ml5BI"};